export default {
  markerMessage: 'مکان مورد نظر خود را انتخاب کنید!',
};
